import script from "./Location.vue?vue&type=script&setup=true&lang=js"
export * from "./Location.vue?vue&type=script&setup=true&lang=js"

import "./Location.vue?vue&type=style&index=0&id=07a87fab&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a87fab"]])

export default __exports__